const headRowsManagementService = {
  date: 'Data',
  equipmentEquipmentParamName: 'Equipamento',
  inspection: 'Tipo de Serviço',
  questions: 'Checklist',
  placeName: 'Local',
  user: 'Realizado por',
  description: 'Observação',
  score: 'Pontuação',
};

export default headRowsManagementService;
